import { useEffect } from "react";
import { COOKIE_CONSENT_ACCEPTED_EVENT, hasCookieConsent } from "@/lib/privacyConsent";

const DEFAULT_GTM_ID = "GTM-TNPV6VHN";

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

function appendScript(id: string, src: string): void {
  if (document.getElementById(id)) return;

  const script = document.createElement("script");
  script.id = id;
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
}

function loadGoogleTagManager(gtmId: string): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  appendScript("gtm-script", `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`);
}

function loadConsentedTrackers(): void {
  const gtmId = import.meta.env.VITE_GTM_ID || DEFAULT_GTM_ID;
  if (gtmId) {
    loadGoogleTagManager(gtmId);
  }
}

export function ThirdPartyScripts() {
  useEffect(() => {
    if (hasCookieConsent()) {
      loadConsentedTrackers();
      return;
    }

    const onConsent = () => loadConsentedTrackers();
    window.addEventListener(COOKIE_CONSENT_ACCEPTED_EVENT, onConsent, { once: true });
    return () => window.removeEventListener(COOKIE_CONSENT_ACCEPTED_EVENT, onConsent);
  }, []);

  return null;
}
